export const reservedValues = [
  'abstract',
  'arguments',
  'await',
  'boolean',
  'break',
  'byte',
  'case',
  'catch',
  'char',
  'class',
  'const',
  'continue',
  'debugger',
  'default',
  'delete',
  'do',
  'double',
  'else',
  'enum',
  'eval',
  'export',
  'extends',
  'false',
  'final',
  'finally',
  'float',
  'for',
  'function',
  'goto',
  'if',
  'implements',
  'import',
  'in',
  'instanceof',
  'int',
  'interface',
  'let',
  'long',
  'native',
  'new',
  'null',
  'package',
  'private',
  'protected',
  'public',
  'return',
  'short',
  'static',
  'super',
  // 'switch', //* Commented to allow switch
  'synchronized',
  'this',
  'throw',
  'throws',
  'transient',
  'true',
  'try',
  'typeof',
  'var',
  'void',
  'volatile',
  'while',
  'with',
  'yield',
  'abstract',
  'boolean',
  'byte',
  'char',
  'double',
  'final',
  'float',
  'goto',
  'int',
  'long',
  'native',
  'short',
  'synchronized',
  'throws',
  'transient',
  'volatile',
  'array',
  'date',
  'eval',
  'function',
  'hasownproperty',
  'infinity',
  'isfinite',
  'isnan',
  'isprototypeOf',
  'length',
  'math',
  'nan',
  'object',
  'prototype',
  'string',
  'tostring',
  'undefined',
  'valueof',
  'getclass',
  'java',
  'javaarray',
  'javaclass',
  'javaobject',
  'javapackage',
  'alert',
  'all',
  'anchor',
  'anchors',
  'area',
  'assign',
  'blur',
  'button',
  'checkbox',
  'clearinterval',
  'cleartimeout',
  'clientInformation',
  'close',
  'closed',
  'confirm',
  'constructor',
  'crypto',
  'decodeuri',
  'decodeuricomponent',
  'defaultstatus',
  'embed',
  'embeds',
  'encodeuri',
  'encodeuricomponent',
  'escape',
  'event',
  'fileupload',
  'focus',
  'form',
  'forms',
  'frame',
  'innerheight',
  'innerwidth',
  'layer',
  'layers',
  'link',
  'mimetypes',
  'navigate',
  'navigator',
  'frames',
  'framerate',
  'hidden',
  'offscreenbuffering',
  'open',
  'opener',
  'option',
  'outerHeight',
  'outerWidth',
  'packages',
  'pagexoffset',
  'pageyoffset',
  'parent',
  'parsefloat',
  'parseint',
  'pkcs11',
  'plugin',
  'prompt',
  'propertyisenum',
  'radio',
  'reset',
  'screenX',
  'screenY',
  'scroll',
  'secure',
  'select',
  'self',
  'setinterval',
  'settimeout',
  'status',
  'submit',
  'taint',
  'text',
  'textarea',
  'top',
  'unescape',
  'untaint',
  'window',
  'onblur',
  'onclick',
  'onerror',
  'onfocus',
  'onkeydown',
  'onkeypress',
  'onkeyup',
  'onmouseover',
  'onload',
  'onmouseup',
  'onmousedown',
  'onsubmit',
  'permission',
];

export const notAllowedWord = [
  'xxx',
  'xx',
  'tit',
  'porn',
  'gross',
  'crude',
  'obscene',
  'indecent',
  'lustful',
  'lascivious',
  'filthy',
  'kinky',
  'soft-core',
  'lewd',
  'coarse',
  'bawdy',
  'naughty',
  'racy',
  'unbecoming',
  'indecorous',
  'earthy',
  'foul',
  'wicked',
  'salty',
  'profane',
  'wanton',
  'nasty',
  'debasing',
  'nude',
  'boobs',
  'booty',
  'ass',
  'dick',
  'penis',
  'cum',
  'blowjob',
  'titjob',
  'rimjob',
  'spank',
  'handjob',
  'masturbation',
  'bdsm',
  'prurient',
  'ribald',
  'smutty',
  'salacious',
  'dirty',
  'vulgar',
  'unprintable',
  'perverted',
  'immodest',
];
